function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && (typeof module === "undefined" ? "undefined" : _typeof(module)) < "u" ? module.exports = factory(require("@hotwired/stimulus")) : typeof define == "function" && define.amd ? define(["@hotwired/stimulus"], factory) : (global = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : global || self, global.StimulusRailsNestedForm = factory(global.Stimulus));
})(this, function (stimulus) {
  "use strict";

  var _RailsNestedForm = /*#__PURE__*/function (_stimulus$Controller) {
    _inherits(_RailsNestedForm, _stimulus$Controller);
    var _super = _createSuper(_RailsNestedForm);
    function _RailsNestedForm() {
      _classCallCheck(this, _RailsNestedForm);
      return _super.apply(this, arguments);
    }
    _createClass(_RailsNestedForm, [{
      key: "add",
      value: function add(e) {
        e.preventDefault();
        var content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString());
        this.targetTarget.insertAdjacentHTML("beforebegin", content);
        var event = new CustomEvent("rails-nested-form:add", {
          bubbles: !0
        });
        this.element.dispatchEvent(event);
      }
    }, {
      key: "remove",
      value: function remove(e) {
        e.preventDefault();
        var wrapper = e.target.closest(this.wrapperSelectorValue);
        if (wrapper.dataset.newRecord === "true") wrapper.remove();else {
          wrapper.style.display = "none";
          var input = wrapper.querySelector("input[name*='_destroy']");
          input.value = "1";
        }
        var event = new CustomEvent("rails-nested-form:remove", {
          bubbles: !0
        });
        this.element.dispatchEvent(event);
      }
    }]);
    return _RailsNestedForm;
  }(stimulus.Controller);
  _RailsNestedForm.targets = ["target", "template"], _RailsNestedForm.values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper"
    }
  };
  var RailsNestedForm = _RailsNestedForm;
  return RailsNestedForm;
});